<template>
  <div>
    <div class="flex items-center bg-gray-800 px-2">
      <div class="flex py-4">
        <img class="w-5 h-5" src="../../assets/icons/input.svg" alt="Entrez un nom pour le nouveau label" />
        <input
          v-model="labelName"
          class="px-2 w-48 bg-gray-800 text-white focus:outline-none placeholder-gray-600 "
          type="text"
          placeholder="Nom du label"
        />
      </div>
      <div class="flex items-center justify-center w-8 h-8 rounded-full" :style="backgroundColor">
        <input
          v-model="labelInitials"
          class="w-8 text-center bg-transparent focus:outline-none"
          :style="fontColor"
          type="text"
        />
      </div>
    </div>
    <div class="flex flex-col bg-gray-700 px-2 py-4 text-sm">
      <Toggle
        class="w-full"
        name="pastelColorsIsActive"
        title="Couleurs pastelles"
        on="OK"
        off="No"
        :checked="pastelColorsIsActive"
        @toggle="toggleLabelPastelColorsIsActive"
      />
      <ul v-if="pastelColorsIsActive" class="flex flex-wrap pt-4">
        <li
          v-for="(pastelColor, index) in pastelColors"
          :key="index"
          class="w-10 h-10 m-1 border-2 rounded-full"
          :style="
            [labelColor === pastelColor.bg ? 'background-color:' + pastelColor.bg + ';' : ''] +
              'border-color:' +
              pastelColor.bg + ';' +
              ''
          "
          @mouseover="setBgColor(pastelColor.bg, pastelColor.id, $event)"
          @mouseleave="removeBgColor"
          @click="setColor(pastelColor.id, pastelColor.name)"
        ></li>
      </ul>
      <ul v-else class="flex flex-wrap pt-4">
        <li
          v-for="(brightColor, index) in brightColors"
          :key="index"
          class="w-10 h-10 m-1 border-2 rounded-full"
          :style="
            [labelColor === brightColor.bg ? 'background-color:' + brightColor.bg + ';' : ''] +
              'border-color:' +
              brightColor.bg
          "
          @click="setColor(brightColor.id, brightColor.name)"
          @mouseover="setBgColor(brightColor.bg, brightColor.id, $event)"
          @mouseleave="removeBgColor"
        ></li>
      </ul>
      <Toggle
        class="pt-4 w-full"
        name="shadowIsActive"
        title="Ombre"
        on="OK"
        off="No"
        :checked="shadowIsActive"
        @toggle="toggleShadowIsActive"
      />
    </div>
    <div class="flex flex-col bg-gray-800 px-2 py-4 text-sm">
      <div class="flex justify-center">
        <Toggle
          class="w-full"
          name="isForPilotOnly"
          title="Accessible aux participants"
          on="OK"
          off="No"
          :checked="!labelIsForPilotOnly"
          @toggle="labelIsForPilotOnly = !labelIsForPilotOnly"
        />
      </div>
    </div>
    <button
      v-if="labelName && labelColor && !isInEditMode && labelsCount <= 12"
      @click="
        handleNewLabel({
          text: labelName,
          color: labelColor,
          initials: labelInitials,
          is_for_pilot_only: labelIsForPilotOnly,
          is_default: false,
        })
      "
      class="bg-green font-light text-white w-full py-3 focus:outline-none"
    >
      Ajouter le label
    </button>
    <div
      v-if="!isInEditMode && labelsCount >= 12"
      class="text-center font-light bg-red-500 text-white w-full py-3 focus:outline-none"
    >
      12 labels max autorisés
    </div>
    <button
      v-if="isInEditMode && !isDefault"
      @click="handleDeleteLabel"
      class="flex px-2 bg-gray-700 font-light text-white w-full py-3 focus:outline-none"
    >
      <img class="h-6 pr-2" src="../../assets/icons/bin-red.svg" alt="Supprimer le label" />
      Supprimer le label ...
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex"
import Toggle from "../utils/Toggle"

export default {
  props: {
    name: String,
    color: String,
    initials: String,
    isForPilotOnly: Boolean,
    isDefault: Boolean,
    order: Number,
    isInEditMode: Boolean,
    edited: Boolean,
    editedIndex: Number,
  },
  data() {
    return {
      labelName: this.name,
      labelColor: this.color,
      labelInitials: this.initials,
      labelIsForPilotOnly: this.isForPilotOnly,
    }
  },
  components: {
    Toggle,
  },
  computed: {
    ...mapGetters("labels", ["getColors", "labelExistsWithColor"]),
    ...mapState({
      pastelColorsIsActive: (state) => state.labels.options.pastelColorsIsActive,
      pastelColors: (state) => state.labels.pastelColors,
      brightColors: (state) => state.labels.brightColors,
      labelsCount: (state) => state.labels.all.length,
      shadowIsActive: (state) => state.labels.options.shadowIsActive,
      selected: (state) => state.answers.selected,
    }),
    backgroundColor() {
      if (this.labelColor !== null) {
        return "background-color:" + this.getColors(this.labelColor).bg
      }
      return ""
    },
    fontColor() {
      if (this.labelColor !== null) {
        return "color:" + this.getColors(this.labelColor).font
      }
      return ""
    },
  },
  watch: {
    labelName() {
      this.labelInitials = this.getInitials(this.labelName)
    },
    edited() {
      if (this.edited === true) {
        this.editLabel({
          index: this.editedIndex,
          label: {
            text: this.labelName,
            color: this.labelColor,
            initials: this.labelInitials,
            is_for_pilot_only: this.labelIsForPilotOnly,
            order: this.order,
          },
        })
        this.$emit("edited")
      }
    },
  },
  methods: {
    ...mapActions("labels", ["newLabel", "editLabel"]),
    ...mapMutations("labels", ["toggleLabelPastelColorsIsActive", "toggleShadowIsActive"]),
    setBgColor(color, colorId, event) {
      event.target.style.backgroundColor = color
      if (this.labelExistsWithColor(colorId) === true) {
        event.target.style.opacity = "0.3"
        return
      }
      event.target.style.opacity = "0.8"
    },
    removeBgColor(event) {
      event.target.style.backgroundColor = "inherit"
      event.target.style.opacity = "1"
    },
    handleNewLabel(label) {
      this.newLabel(label)
      this.labelName = null
      this.labelColor = null
      this.labelInitials = null

      if (this.selected.length > 0) {
        let event = {
          target: document.querySelector(".label-menu"),
        }
        this.$parent.$parent.$emit("toggleMenu", {
          event: event,
          name: "labelNew",
          withIcon: false,
        })
      } else {
        this.$emit("created")
      }
    },
    handleDeleteLabel() {
      this.$emit("edited")
      let event = {
        target: document.querySelector(".label-menu"),
      }
      this.$parent.$parent.$emit("toggleMenu", {
        event: event,
        name: "labelDelete",
        withIcon: false,
        editedIndex: this.editedIndex,
      })
    },
    getInitials(name) {
      if (name && name.length > 1) {
        let words = name.split(" ")
        if (words.length > 1 && words[1][0]) {
          return words[0][0] + words[1][0]
        }
        return words[0][0] + (words[0][1] ? words[0][1] : "")
      }
      return name
    },
    setColor(color, name) {
      this.labelColor = color
      if (!this.labelName) {
        this.labelName = name.charAt(0).toUpperCase() + name.slice(1)
      }
    },
  },
}
</script>

<style></style>
